// @flow strict

import type {Brand} from 'src/types/brands';

import * as React from 'react';
import classify from 'src/utils/classify';

import {LanguageSupport} from 'src/components/settings/language-support.jsx';

import css from '../booking.css';


export const BrandingHeader = ({
  brand,
  language,
  persistLanguage = true,
}: {
  brand: ?Brand,
  language?: string,
  persistLanguage?: boolean,
}): React.Element<'div'> => (
  <div
    className={classify(css.brandingHeader, {
      [css.brandingHeaderWithoutLogo]: !brand?.logo,
    })}
  >
    {brand?.logo && <img className={css.brandingIcon} src={brand.logo} />}
    <LanguageSupport language={language} persistLanguage={persistLanguage} />
  </div>
);
